import { render, staticRenderFns } from "./list_subcategories_component.vue?vue&type=template&id=458e04f8&scoped=true"
import script from "./list_subcategories_component.vue?vue&type=script&lang=js"
export * from "./list_subcategories_component.vue?vue&type=script&lang=js"
import style0 from "./list_subcategories_component.vue?vue&type=style&index=0&id=458e04f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e04f8",
  null
  
)

export default component.exports